<aero-dialog-header [config]="config" [dialogRef]="dialogRef"></aero-dialog-header>
<div>
  <ng-template aeroDialogContentPlaceholder></ng-template>
</div>
<div *ngIf="config.showInputField" class="container">
  <aero-input type="text"
              [id]="'aero-dialog-input'"
              label="{{config.dialogInput.inputLabel}}"
              name="{{config.dialogInput.inputLabel}}"
              [(ngModel)]="config.dialogInput.inputText"
              [maxlength]="config.dialogInput.maxLength || 60"
              [required]="true"
              (aeroInputNgModelEmitter)="handleInputModelChanges($event)"
              [autofocus]="true">
  </aero-input>
</div>
<aero-dialog-footer *ngIf="config.showFooter"
                    [config]="config"
                    [dialogRef]="dialogRef"
                    [primaryDisabled]="primaryDisabled"
                    [secondaryDisabled]="secondaryDisabled"
></aero-dialog-footer>
